import * as Yup from "yup";

export const ResetPasswordSchema = Yup.object().shape({
  oldPassword: Yup.string().required().min(6),
  newPassword: Yup.string().required().min(6),
  confirmPassword: Yup.string().oneOf([Yup.ref('newPassword'), null]).min(6)
})
